export class CalenderNameViewModel {
  public constructor(
    name: string,
    summaryName: string,
    persianName: string,
    summaryPersianName: string
  ) {
    this.name = name;
    this.summaryName = summaryName;
    this.persianName = persianName;
    this.summaryPersianName = summaryPersianName;
  }

  public name: string;
  public summaryName: string;
  public persianName: string;
  public summaryPersianName: string;
}

export class MonthViewModel {
  public constructor(monthNumber: number, monthName?: CalenderNameViewModel) {
    if (monthName != null) {
      this.monthName = monthName;
    } else {
      this.monthName = new CalenderNameViewModel('', '', '', '');
    }
    this.monthNumber = monthNumber;
    this.weeks = [];
  }

  public weeks: WeekViewModel[];
  public monthName: CalenderNameViewModel;
  public monthNumber: number;
}

export class PersianDateViewModel {
  public constructor(
    day: number,
    dayOfWeek: number,
    month: number,
    year: number,
    dateTime: Date,
    name?: CalenderNameViewModel
  ) {
    this.day = day;
    this.dayOfWeek = dayOfWeek;
    this.month = month;
    this.year = year;
    this.date = `${year}/${month.toString().padStart(2, '0')}/${day
      .toString()
      .padStart(2, '0')}`;
    this.dateTime = dateTime;
    this.name = name;
  }

  public day: number;
  public dayOfWeek: number;
  public month: number;
  public year: number;
  public date: string;
  public dateTime: Date;
  public name?: CalenderNameViewModel;
  public events: any[] = [];
  public checks: any[] = [];
  public factors: any[] = [];
}

export class WeekViewModel {
  public constructor() {
    this.days = [];
  }

  public days: PersianDateViewModel[];
}

export class DatePickerModel {
  public constructor(
    month: CalenderNameViewModel,
    monthNumber: number,
    year: number,
    className: string
  ) {
    this.weeks = [];
    this.month = month;
    this.monthNumber = monthNumber;
    this.year = year;
    this.className = className;
  }

  public weeks: WeekViewModel[];
  public month: CalenderNameViewModel;
  public monthNumber: number;
  public year: number;
  public className: string;
}

export class DayDatePickerModel {
  public constructor(
    weekNumber: number,
    day:PersianDateViewModel
  ) {
    this.day = day;
    this.weekNumber = weekNumber;
  }

  public day: PersianDateViewModel;
  public weekNumber: number;
}
